'use strict';
angular.module('weixinGroupModule', [
    'weixinGroupRouterModule',
])
    .controller('weixinGroupCtrl', ['$scope', 'trsHttpService', '$state', 'wechatBtnService', 'modalDialog', '$stateParams', 'editcenterRightsService', function($scope, trsHttpService, $state, wechatBtnService, modalDialog, $stateParams, editcenterRightsService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
            };
            $scope.status = {
                copyCurrPage: 1,
                zbBtns: false,
                showReason: false,
                qunfaStatus: {
                    '1': '群发中',
                    '2': '群发成功',
                    '3': '群发失败',
                },
            };
            $scope.data = {
                selectedArray: [],
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // requestData();
            initBtnRights();
        }

        /**
         * [selectAll description]全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeixinListBtn('wechat.qunfahistory', $stateParams.wxchannelid).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [requestData description]列表
         * @return {[type]} [description]
         */
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [pageChanged description]获取状态类型
         * @return {[type]} [description]
         */
        $scope.getStatus = function(item) {
            switch (item) {
                case '1':
                    return '发布成功';
                case '2':
                    return '未发布';
                case '0':
                    return '发布失败';
                case '3':
                    return '取消发布';
            }

        };

        /**
         * [findDocDetails description]获取稿件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findDocDetails = function(item) {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'findDocDetails',
                DocIds: item.SENDINGORDER,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {

            });
            wechatBtnService.massSend(item, 'detail', function(data) {

            });
        };

        /**
         * [requestData description]列表刷新
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'querySendCardMessages',
                Channelid: $stateParams.wxchannelid,
                OperTimeStart: $scope.status.fromdate,
                OperTimeEnd: $scope.status.untildate,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
            });
        }

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
    }]);
